import { useSelector } from 'react-redux'
import { Card, CardBody, CardHeader } from 'reactstrap'

function Descriptions() {
  const { jobProps } = useSelector((store) => store.recruitment)

  const description = jobProps?.find((el) => el?.name === 'description')
  const requirements = jobProps?.find((el) => el?.name === 'requirements')

  return (
    <div
      className='d-flex align-items-start justify-content-between'
      style={{ gap: '2rem' }}
    >
      <Card className='w-50'>
        <CardHeader className='title'>Job Questions</CardHeader>
        <CardBody
          className='d-flex justify-content-between'
          dangerouslySetInnerHTML={{ __html: description?.value }}
        ></CardBody>
      </Card>
      <Card className='w-50'>
        <CardHeader className='title'>Custom Questions</CardHeader>
        <CardBody
          className='d-flex justify-content-between'
          dangerouslySetInnerHTML={{ __html: requirements?.value }}
        ></CardBody>
      </Card>
    </div>
  )
}

export default Descriptions
